import { OrdemServicoInterface } from "../../ImportBackend/Interfaces/OrdensServicosInterfaces";
import ClsFormatacao from "../../Utils/ClsFormatacao";

interface rsDescricaoServicosInterface {
  quantidade: number
  valorUnitario: number
  valorTotal: number
  analise: string
}

interface rsDescricaoAmostrasInterface {
  amostraInicial: string
  amostraFinal: string
}

const enum TAMANHO_CAMPOS {
  QTD = 10,
  ANALISE = 40,
  VR_UNITARIO = 12,
  VR_TOTAL = 12
}

interface rsGerarDadosInterface { descricaoServico: string, dadosAdicionaisNF: string, valorTotal: number }

export default class ClsEnviarOS {

  public gerarDados ( rsRelat: Array<OrdemServicoInterface>, rsOSSelecionadas: Array<number> ): rsGerarDadosInterface {

    const clsFormatos: ClsFormatacao = new ClsFormatacao()

    const alinharPorTab = (
      texto: string,
      tamanho: number,
      lado: 'left' | 'right'
    ): string => {
      return lado === 'right' ? texto.padStart( tamanho, ' ' ) : texto.padEnd( tamanho, ' ' )
    }

    let rsDescricaoServicos: Array<rsDescricaoServicosInterface> = []
    let rsDescricaoAmostras: Array<rsDescricaoAmostrasInterface> = []

    let retorno: rsGerarDadosInterface = { descricaoServico: '', dadosAdicionaisNF: '', valorTotal: 0 }

    let tmpValorTotal: number = 0
    let tmpDescricaoServico: string = ''

    rsRelat.forEach( ( rsOS => {

      if ( rsOSSelecionadas.indexOf( rsOS.idOrdemServico as number ) >= 0 ) {

        const index: number = rsDescricaoServicos.findIndex( ( rs ) => rs.analise === rsOS.tipoAnalise && rs.valorUnitario === rsOS.valor )

        if ( index >= 0 ) {
          rsDescricaoServicos[index].quantidade += rsOS.QTD
          rsDescricaoServicos[index].valorTotal += rsOS.valorTotal
        } else {
          rsDescricaoServicos.push( {
            quantidade: rsOS.QTD,
            valorUnitario: rsOS.valor,
            valorTotal: rsOS.valorTotal,
            analise: rsOS.tipoAnalise
          } )
        }

        rsDescricaoAmostras.push( {
          amostraInicial: rsOS.amostraInicial,
          amostraFinal: rsOS.amostraFinal
        } )

      }

    } ) )

    rsDescricaoServicos.forEach( ( rsOS ) => {

      tmpValorTotal += parseFloat( rsOS.valorTotal.toFixed( 2 ) )

      tmpDescricaoServico += 'QTDE: '.concat( alinharPorTab( rsOS.quantidade.toString(), TAMANHO_CAMPOS.QTD, 'right' ).concat( ' ' ) )
      tmpDescricaoServico += 'Unitário: R$'.concat( alinharPorTab( clsFormatos.currency( rsOS.valorUnitario ), TAMANHO_CAMPOS.VR_UNITARIO, 'right' ).concat( ' ' ) )
      tmpDescricaoServico += 'Total: R$'.concat( alinharPorTab( clsFormatos.currency( rsOS.valorTotal ), TAMANHO_CAMPOS.VR_TOTAL, 'right' ).concat( ' ' ) )
      tmpDescricaoServico += 'Análise: '.concat( alinharPorTab( rsOS.analise, TAMANHO_CAMPOS.ANALISE, 'left' ).concat( '\n' ) )

    } )

    rsDescricaoAmostras.sort( ( a, b ) => parseInt( a.amostraInicial ) - parseInt( b.amostraInicial ) )

    // console.log( rsDescricaoAmostras )
    // let tmpInicial: number = rsDescricaoAmostras.length > 0 ? parseInt(rsDescricaoAmostras[0].amostraInicial) : 0
    // let tmpFinal: number = rsDescricaoAmostras.length > 0 ? parseInt(rsDescricaoAmostras[0].amostraFinal) : 0
    let tmpInicial: number = 0
    let tmpFinal: number = 0

    rsDescricaoAmostras.forEach( ( rsAmostra ) => {

      if ( tmpInicial === 0 ) {
        tmpInicial = parseInt( rsAmostra.amostraInicial )
      }

      if ( tmpFinal === 0 || parseInt( rsAmostra.amostraInicial ) === tmpFinal + 1 ) {
        tmpFinal = parseInt( rsAmostra.amostraFinal )
      } else {
        retorno.dadosAdicionaisNF += tmpFinal !== tmpInicial ? `AMOSTRAS DE: ${tmpInicial} a ${tmpFinal}\n` : 'AMOSTRA: '.concat( tmpInicial.toString() ).concat( '\n' )
        tmpInicial = parseInt( rsAmostra.amostraInicial )
        tmpFinal = parseInt( rsAmostra.amostraFinal )
      }

    } )

    // retorno.dadosAdicionaisNF += `AMOSTRAS DE: ${tmpInicial} a ${tmpFinal}\n`

    if ( tmpInicial !== 0 && tmpFinal !== 0 ) {
      retorno.dadosAdicionaisNF += tmpFinal !== tmpInicial ? `AMOSTRAS DE: ${tmpInicial} a ${tmpFinal}\n` : 'AMOSTRA: '.concat( tmpInicial.toString() ).concat( '\n' )
    }

    retorno.valorTotal = parseFloat( tmpValorTotal.toFixed( 2 ) )
    retorno.descricaoServico = tmpDescricaoServico

    return retorno

  }

  /*
  public gerarDados ( rsRelat: Array<OrdemServicoInterface>, rsOSSelecionadas: Array<number> ): rsGerarDadosInterface {

    const alinharPorTab = (
      texto: string,
      tamanho: number,
      lado: 'left' | 'right'
    ): string => {
      return lado === 'right' ? texto.padStart( tamanho, ' ' ) : texto.padEnd( tamanho, ' ' )
    }

    let retorno: rsGerarDadosInterface = { descricaoServico: '', dadosAdicionaisNF: '', valorTotal: 0 }

    let tmpValorTotal: number = 0
    let tmpDescricaoServico: string = ''

    // let tmpRelat: Array<OrdemServicoInterface> = []

    rsRelat.forEach( ( rsOS => {

      // console.log( rsOS.valorTotal )

      if ( rsOSSelecionadas.indexOf( rsOS.idOrdemServico as number ) >= 0 ) {

        tmpValorTotal += parseFloat( rsOS.valorTotal.toFixed( 2 ) )

        retorno.dadosAdicionaisNF += `AMOSTRAS DE: ${rsOS.amostraInicial} a ${rsOS.amostraFinal}\n`

        tmpDescricaoServico += 'QTDE: '.concat(alinharPorTab( rsOS.QTD.toString(), TAMANHO_CAMPOS.QTD, 'right' ).concat( ' ' ))
        tmpDescricaoServico += 'Unitário: R$'.concat(alinharPorTab( rsOS.valor.toFixed( 2 ), TAMANHO_CAMPOS.VR_UNITARIO, 'right' ).concat( ' ' ))
        tmpDescricaoServico += 'Total: R$'.concat(alinharPorTab( rsOS.valorTotal.toFixed( 2 ), TAMANHO_CAMPOS.VR_TOTAL, 'right' ).concat( ' ' ))
        tmpDescricaoServico += 'Análise: '.concat(alinharPorTab( rsOS.tipoAnalise, TAMANHO_CAMPOS.ANALISE, 'left' ).concat( '\n' ))

      }

    } ) )

    retorno.valorTotal = parseFloat( tmpValorTotal.toFixed( 2 ) )
    retorno.descricaoServico = tmpDescricaoServico

    return retorno

  }
  */

}